module.exports = __webpack_public_path__ + "img/icon-remove-target.23160660.svg";